import axios from 'axios';

import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Translation, TranslationRequest } from './TranslationTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Translation>>('/author/translations/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Translation>(`/author/translations/${id}`).then(getData);
}

export function edit(id: Id, request: TranslationRequest) {
  return axios.put<Translation>(`/author/translations/${id}`, request).then(getData);
}

export function create(request: TranslationRequest) {
  return axios.post<Translation>(`/author/translations`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/translations/${id}`).then(getData);
}

export function addNewAlias(translationId: Id, request: PublicationNewAliasRequest) {
  return axios.put(`/author/translations/${translationId}/add-new-alias`, request).then(getData);
}
